import { addLastPrefixSA } from '../transforms/addLastPrefix';
import { formatOrdinalSA } from '../transforms/formatOrdinal';
import { overrideBaseLocale } from './base-config';
export var arSA = overrideBaseLocale('ar-SA', {
    dayOfMonthOrdinal: {
        options: {
            day: 'numeric',
        },
        transforms: [formatOrdinalSA],
    },
    dayOfMonth: {
        options: {
            day: 'numeric',
        },
        transforms: [addLastPrefixSA],
    },
});
//# sourceMappingURL=ar-SA.js.map